export const METRIC_EVENTS = {
  SIGNUP_COMPLETED: "SIGNUP_COMPLETED",
};
